import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function DiscardNewTemplateDialog({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) {
  const isDesktop = useTwBreakpoint("lg");
  const navigate = useNavigate();
  const { search } = useLocation();

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Close = isDesktop ? DialogClose : DrawerClose;
  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Content className="lg:w-[448px]">
        <Title>Discard new template?</Title>
        <Description className="mb-8">
          Are you sure you want to discard this template?
        </Description>

        <div className="flex justify-between items-center gap-x-2.5">
          <Close asChild>
            <Button variant="secondary-black" className="lg:flex-1">
              Cancel
            </Button>
          </Close>

          <Button
            data-cy="delete-template-button"
            variant="outline-danger"
            className="lg:flex-1"
            onClick={() => navigate({ pathname: "..", search })}
          >
            Discard
          </Button>
        </div>
      </Content>
    </Component>
  );
}
